"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signal = void 0;
var tslib_1 = require("tslib");
var ui_signal_1 = require("@hopin-team/ui-signal");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Positions = {
    tiny: {
        top: -0.3,
        left: 1.1,
    },
    small: {
        top: -0.3,
        left: 1.6,
    },
    medium: {
        top: -0.3,
        left: 2.1,
    },
};
var WithLabelPositions = {
    tiny: {
        top: -0.6,
        left: 0.9,
    },
    small: {
        top: -0.6,
        left: 1.4,
    },
    medium: {
        top: -0.6,
        left: 1.9,
    },
};
var makePositionsStyles = function (_a) {
    var sizeOption = _a.sizeOption, withLabel = _a.withLabel;
    if (withLabel && sizeOption) {
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      top: ", "rem;\n      left: ", "rem;\n    "], ["\n      top: ", "rem;\n      left: ", "rem;\n    "])), WithLabelPositions[sizeOption].top, WithLabelPositions[sizeOption].left);
    }
    else if (sizeOption) {
        return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      top: ", "rem;\n      left: ", "rem;\n    "], ["\n      top: ", "rem;\n      left: ", "rem;\n    "])), Positions[sizeOption].top, Positions[sizeOption].left);
    }
    return;
};
exports.Signal = (0, styled_components_1.default)(ui_signal_1.Signal).withConfig({
    shouldForwardProp: function (prop) { return !['sizeOption', 'withLabel'].includes(prop); },
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n\n  ", ";\n"], ["\n  position: absolute;\n\n  ", ";\n"])), function (props) { return makePositionsStyles(props); });
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=signal.js.map